var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogin1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 465.566,
    height: 350.75,
    viewBox: "0 0 465.566 350.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1238",
    "data-name": "Group 1238",
    transform: "translate(-197.875 -198.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1234",
    "data-name": "Group 1234",
    transform: "translate(9.052 13)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10",
    "data-name": "Ellipse 10",
    cx: 153,
    cy: 153,
    r: 153,
    transform: "translate(268.948 185.25)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1237",
    "data-name": "Group 1237"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Model_6",
    "data-name": "Model 6",
    transform: "translate(224.728 233.583)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_350",
    "data-name": "Path 350",
    d: "M-1081.954,461.365l1.858-18.5,10.749.743.176,18.093-1.5,11.35-8.456,2.1Z",
    transform: "translate(1131.718 -402.949)",
    fill: "#fff",
    stroke: "#5f5f5f",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_351",
    "data-name": "Path 351",
    d: "M-1051.28,449.882s-38.277-1.067-45.211,15.678c-3.886,9.357-4.164,25.057-4.164,25.057s6.915,4.409,17.192,2.434c0,0,1.7,36.212-.457,45.269l62.468-1.051,4.739-50.048,15.3-3.034s1.611-19.578-13.79-29.849c-6.754-4.7-23.288-4.114-23.288-4.114S-1043.522,470.142-1051.28,449.882Z",
    transform: "translate(1101.043 -391.468)",
    fill: "#073aaa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_352",
    "data-name": "Path 352",
    d: "M-1100.2,465.322s-2.411,20.7,2.448,22.572c20.568,10.693,28.88,8.407,33.112,11,1.02,6.141,36.16,5.505,20.288-.042-3.477-2.192-18.58-7.573-29.091-15.372-2.669-1.98-5.333-4.906-5.217-8.227a57.174,57.174,0,0,1,1.476-9.819S-1095.182,467.587-1100.2,465.322Z",
    transform: "translate(1100.801 -366.119)",
    fill: "#fff",
    stroke: "#5e5f5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_353",
    "data-name": "Path 353",
    d: "M-1057.917,446.9a72.71,72.71,0,0,1-1.949,14.686,13.738,13.738,0,0,1-5.885,8.317l-.531.346a9.429,9.429,0,0,1-10.1.119h0a13.467,13.467,0,0,1-6.11-8.832A106.711,106.711,0,0,1-1084.1,446.9s-1.5-15.8,13.009-15.483C-1056.6,431.728-1057.917,446.9-1057.917,446.9Z",
    transform: "translate(1128.119 -421.748)",
    fill: "#fff",
    stroke: "#5f5f5f",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_354",
    "data-name": "Path 354",
    d: "M-1047.473,451.452l-.008-.008c-.277,4.882-3.3,6.868-3.3,6.868a46.1,46.1,0,0,0,.029-6.8l.045-1.476a5.648,5.648,0,0,1-1.212-.848c-3.219-3.232-2.894-6.171-2.78-6.8-1.12,5.545-6.812,7.137-7.168,7.224,2.223-1.906,2.141-6.163,2.141-6.163-2.558,3.615-9.1,6.947-13.957,8.328l-.066.026a14.25,14.25,0,0,1-2.107.552,37.041,37.041,0,0,0-.021,5.951,8.384,8.384,0,0,1-3.1-5.761,11.609,11.609,0,0,1-8.317-4.568c2.6.718,5.032-.388,5.692-3.007a6.8,6.8,0,0,1-2.733.335c-3.343,0-4.3-3.34-4.3-3.34s.845.861,5.228.029c3.953-.763,6.767-12.882,16.286-13.4,5.23-.28,7.559,2.419,7.559,2.419.016-1.164-2.538-3.271-2.538-3.271,9.513,1.368,7.942,7.72,7.942,7.72C-1043.814,436.284-1047.473,451.452-1047.473,451.452Z",
    transform: "translate(1120.77 -427.75)",
    fill: "#8c8c8c"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_30",
    "data-name": "Line 30",
    y1: 17.535,
    x2: 1.839,
    transform: "translate(23.613 81.783)",
    fill: "none",
    stroke: "#5e5f5e",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), /*#__PURE__*/React.createElement("g", {
    id: "Model_5",
    "data-name": "Model 5",
    transform: "translate(419.257 232.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_355",
    "data-name": "Path 355",
    d: "M-1008.237,461.411l1.858-18.5,10.749.743.176,18.093-1.5,11.35-8.456,2.1Z",
    transform: "translate(1058.11 -401.79)",
    fill: "#fff",
    stroke: "#5e5f5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_356",
    "data-name": "Path 356",
    d: "M-977.563,449.984s-36.9-2.353-44.511,15.676c-3.884,9.357-4.863,25.057-4.863,25.057s6.915,4.412,17.191,2.437c0,0,1.7,36.212-.457,45.268l62.468-1.051,4.74-50.05,15.3-3.034s1.61-19.578-13.791-29.849c-6.754-4.7-23.288-4.114-23.288-4.114S-969.806,470.243-977.563,449.984Z",
    transform: "translate(1027.435 -390.362)",
    fill: "#0e55e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_357",
    "data-name": "Path 357",
    d: "M-1026.628,465.348s-2.2,20.756,2.656,22.625c20.568,10.693,28.943,9.516,33.173,12.109.98,5.885,33.292,5.545,22.015.626q-1.727-.752-3.417-1.576c-5.289-2.588-18.129-7.586-27.4-14.464-2.669-1.98-5.4-6.012-5.281-9.334a57.15,57.15,0,0,1,1.476-9.817S-1021.606,467.613-1026.628,465.348Z",
    transform: "translate(1027.125 -364.994)",
    fill: "#fff",
    stroke: "#5e5f5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_358",
    "data-name": "Path 358",
    d: "M-985.459,447.242a73.3,73.3,0,0,1-2.289,14.073,12.979,12.979,0,0,1-5.487,7.57l-.478.306a8.4,8.4,0,0,1-8.983.108h0a12.425,12.425,0,0,1-5.561-8.032,107.449,107.449,0,0,1-1.74-14.025s-1.782-16.243,12.325-15.908C-983.6,431.67-985.459,447.242-985.459,447.242Z",
    transform: "translate(1055.107 -420.797)",
    fill: "#fff",
    stroke: "#5e5f5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_359",
    "data-name": "Path 359",
    d: "M-975.314,452.347l-.005-.008c-.473,4.813-3.348,6.743-3.348,6.743a48.4,48.4,0,0,0,.272-6.675l.1-1.476a5.067,5.067,0,0,1-1.114-.853c-2.949-3.282-2.556-6.31-2.429-6.96a10.224,10.224,0,0,1-6.979,7.393c2.134-1.93,2.131-6.289,2.131-6.289-2.492,3.707-8.7,7.076-13.257,8.454l-.061.026a12.931,12.931,0,0,1-1.97.549,38.515,38.515,0,0,0,.084,5.83,8.5,8.5,0,0,1-3-5.642,11.42,11.42,0,0,1-8-4.581,3.926,3.926,0,0,0,5.3-3.068,6.043,6.043,0,0,1-2.6.343c-3.187,0-4.256-3.454-4.256-3.454s.85.9,5.027.029c3.778-.8,6.231-13.846,15.668-14.419,5.2-.314,7.456,2.672,7.456,2.672.04-1.283-2.461-3.623-2.461-3.623,9.415,1.523,7.652,8.457,7.652,8.457C-971.058,436.671-975.314,452.347-975.314,452.347Z",
    transform: "translate(1047.925 -427.34)",
    fill: "#8c8c8c"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_31",
    "data-name": "Line 31",
    y1: 17.535,
    x2: 1.839,
    transform: "translate(23.722 82.988)",
    fill: "none",
    stroke: "#5e5f5e",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), /*#__PURE__*/React.createElement("g", {
    id: "I_mac",
    "data-name": "I mac",
    transform: "translate(274.998 305.73)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_72",
    "data-name": "Rectangle 72",
    width: 67.348,
    height: 5.263,
    transform: "translate(0 65.092)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_360",
    "data-name": "Path 360",
    d: "M-1016.838,503.911l-56.1-.37a7.557,7.557,0,0,1-7.507-7.607l.206-31.425a9.5,9.5,0,0,1,9.561-9.434l57.337.378a8.165,8.165,0,0,1,8.111,8.217l-.19,28.967A11.351,11.351,0,0,1-1016.838,503.911Z",
    transform: "translate(1083.93 -455.075)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_361",
    "data-name": "Path 361",
    d: "M-1067.868,466.833l-.378,29.086,12.046-.265,1.064-28.04",
    transform: "translate(1103.932 -435.788)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_362",
    "data-name": "Path 362",
    d: "M-1039.126,488.74l-33.036.322v-.116a11.489,11.489,0,0,1,11.377-11.6l10.054-.1a11.489,11.489,0,0,1,11.6,11.38Z",
    transform: "translate(1097.51 -418.707)",
    fill: "#ececec"
  })), /*#__PURE__*/React.createElement("g", {
    id: "I_mac-2",
    "data-name": "I mac",
    transform: "translate(465.448 306.82)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_73",
    "data-name": "Rectangle 73",
    width: 67.348,
    height: 5.263,
    transform: "translate(0 65.092)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_363",
    "data-name": "Path 363",
    d: "M-944.707,504.324l-56.1-.37a7.559,7.559,0,0,1-7.507-7.607l.208-31.425a9.5,9.5,0,0,1,9.561-9.434l57.337.378a8.162,8.162,0,0,1,8.108,8.217l-.19,28.967A11.348,11.348,0,0,1-944.707,504.324Z",
    transform: "translate(1011.798 -455.488)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_364",
    "data-name": "Path 364",
    d: "M-995.312,467.246l-.378,29.086,12.046-.265,1.064-28.04",
    transform: "translate(1032.499 -436.201)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_365",
    "data-name": "Path 365",
    d: "M-966.593,489.361l-33.036-.029v-.116a11.491,11.491,0,0,1,11.5-11.48l10.054.008a11.491,11.491,0,0,1,11.48,11.5Z",
    transform: "translate(1026.038 -418.993)",
    fill: "#ececec"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Table",
    transform: "translate(198 375.813)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_366",
    "data-name": "Path 366",
    d: "M-645.609,494.28h-465.316V481.618h465.316Z",
    transform: "translate(1110.924 -481.618)",
    fill: "#f6f7f7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_367",
    "data-name": "Path 367",
    d: "M-838.935,494.28h-271.99V481.618h465.316V494.28H-745.3",
    transform: "translate(1110.924 -481.618)",
    fill: "none",
    stroke: "#5f5f5f",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_74",
    "data-name": "Rectangle 74",
    width: 351.538,
    height: 133.676,
    transform: "translate(58.419 12.662)",
    fill: "#f6f7f7",
    stroke: "#5f5f5f",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_368",
    "data-name": "Path 368",
    d: "M-1077.632,620.09h-13.776V486.414h13.776Z",
    transform: "translate(1142.939 -473.752)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_369",
    "data-name": "Path 369",
    d: "M-1091.407,522.769V486.414h13.776V620.09h-13.776V608.944",
    transform: "translate(1142.939 -473.752)",
    fill: "none",
    stroke: "#5f5f5f",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_370",
    "data-name": "Path 370",
    d: "M-945.6,620.09h-13.776V486.414H-945.6V620.09Z",
    transform: "translate(1359.521 -473.752)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_371",
    "data-name": "Path 371",
    d: "M-944.49,544.017V620.09h-13.776V486.414h13.776v16.614",
    transform: "translate(1361.335 -473.752)",
    fill: "none",
    stroke: "#5f5f5f",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), /*#__PURE__*/React.createElement("g", {
    id: "Model_2",
    "data-name": "Model 2",
    transform: "translate(304.285 257.963)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_76",
    "data-name": "Rectangle 76",
    d: "M3.677,0H63.212a3.677,3.677,0,0,1,3.677,3.677V11.12a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V3.677A3.677,3.677,0,0,1,3.677,0Z",
    transform: "translate(25.874 279.396)",
    fill: "#f5f6f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_395",
    "data-name": "Path 395",
    d: "M-1070.547,484.659a92.265,92.265,0,0,1,1.8-10.654",
    transform: "translate(1070.872 -376.256)",
    fill: "none",
    stroke: "#5e5f5e",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_271",
    "data-name": "Group 271",
    transform: "translate(20.779 142.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_266",
    "data-name": "Group 266"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_263",
    "data-name": "Group 263",
    transform: "translate(19.681 111.342)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_396",
    "data-name": "Path 396",
    d: "M-1039.7,558.449l-9.276,3.81-6.372-25.325,9.276-3.81Z",
    transform: "translate(1055.346 -533.124)",
    fill: "#f5f6f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_397",
    "data-name": "Path 397",
    d: "M-1039.7,558.449l-9.276,3.81-6.372-25.325,9.276-3.81Z",
    transform: "translate(1055.346 -533.124)",
    fill: "#f5f6f6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_264",
    "data-name": "Group 264",
    transform: "translate(40.475 111.733)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_398",
    "data-name": "Path 398",
    d: "M-1038.182,561.855l-9.288-2.736,4.664-25.847,9.289,2.736Z",
    transform: "translate(1047.471 -533.272)",
    fill: "#f5f6f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_399",
    "data-name": "Path 399",
    d: "M-1038.182,561.855l-9.288-2.736,4.664-25.847,9.289,2.736Z",
    transform: "translate(1047.471 -533.272)",
    fill: "#f5f6f6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_265",
    "data-name": "Group 265"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_400",
    "data-name": "Path 400",
    d: "M-988.409,527.768c-1.695,20.859-13.595,75.139-19.95,92.779l-15.911-4.528c1.529-11.734,6.612-50.327,10.649-75.485.383-2.347-.808-4.644-2.7-5.238l-.024-.011-9.233-2.844v-.01c0-.019-.008-.066-.008-.153-.005.087-.013.135-.013.153v.01l-9.233,2.844c-1.906.584-3.1,2.891-2.728,5.249,4.053,25.2,9.152,63.915,10.665,75.551l-15.459,4.05c-6.4-17.754-18.722-71.558-20.41-92.367a17.827,17.827,0,0,1,.016-2.588l.024-.248a31.508,31.508,0,0,1,2.912-11.089l6.017-22.889,51.344,2.548,5.325,13a14.533,14.533,0,0,1,1.558,1.772c.895,1.2,1.821,2.366,2.793,3.467C-989.7,515.213-988.094,523.832-988.409,527.768Z",
    transform: "translate(1062.8 -490.954)",
    fill: "#f5f6f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_401",
    "data-name": "Path 401",
    d: "M-988.409,527.768c-1.695,20.859-13.595,75.139-19.95,92.779l-15.911-4.528c1.529-11.734,6.612-50.327,10.649-75.485.383-2.347-.808-4.644-2.7-5.238l-.024-.011-9.233-2.844v-.01c0-.019-.008-.066-.008-.153-.005.087-.013.135-.013.153v.01l-9.233,2.844c-1.906.584-3.1,2.891-2.728,5.249,4.053,25.2,9.152,63.915,10.665,75.551l-15.459,4.05c-6.4-17.754-18.722-71.558-20.41-92.367a17.827,17.827,0,0,1,.016-2.588l.024-.248a31.508,31.508,0,0,1,2.912-11.089l6.017-22.889,51.344,2.548,5.325,13a14.533,14.533,0,0,1,1.558,1.772c.895,1.2,1.821,2.366,2.793,3.467C-989.7,515.213-988.094,523.832-988.409,527.768Z",
    transform: "translate(1062.8 -490.954)",
    fill: "#f5f6f6"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_402",
    "data-name": "Path 402",
    d: "M-1028.022,548.7l-19.718-6.2a1.519,1.519,0,0,1-.837-1.764l.684-3.543c.15-.782.768-1.26,1.381-1.069l19.718,6.2a1.517,1.517,0,0,1,.834,1.764l-.681,3.543C-1026.792,548.411-1027.413,548.889-1028.022,548.7Z",
    transform: "translate(1086.076 -416.935)",
    fill: "#f5f6f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_403",
    "data-name": "Path 403",
    d: "M-1036.5,542.718l-18.643,4.436c-.62.145-1.214-.375-1.331-1.167l-.523-3.588a1.474,1.474,0,0,1,.913-1.7l18.643-4.436c.618-.148,1.215.375,1.331,1.167l.523,3.588A1.474,1.474,0,0,1-1036.5,542.718Z",
    transform: "translate(1072.294 -416.674)",
    fill: "#f5f6f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_404",
    "data-name": "Path 404",
    d: "M-1053.707,545.508a.962.962,0,0,1,.805-.882,16.617,16.617,0,0,0,5.017-1.164,18.842,18.842,0,0,0,4.555-2.64.736.736,0,0,1,1.088.185,15.889,15.889,0,0,1,1.833,3.345,31.414,31.414,0,0,1,1.779,6.767l-12.755,5.626a23.092,23.092,0,0,1-2.278-6.091A15.3,15.3,0,0,1-1053.707,545.508Z",
    transform: "translate(1077.392 -409.425)",
    fill: "#f5f6f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_405",
    "data-name": "Path 405",
    d: "M-1045.795,540.832a.743.743,0,0,1,1.035-.288,17.673,17.673,0,0,0,4.845,2.03,16.127,16.127,0,0,0,4.99.449.915.915,0,0,1,.885.824,19.1,19.1,0,0,1,.367,4.055,32.725,32.725,0,0,1-.959,7.037c-4.436-.938-9.41-1.014-13.849-1.951a38.7,38.7,0,0,1,.8-7.607A13.4,13.4,0,0,1-1045.795,540.832Z",
    transform: "translate(1086.248 -409.787)",
    fill: "#f5f6f6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_270",
    "data-name": "Group 270"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_267",
    "data-name": "Group 267",
    transform: "translate(19.681 111.342)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_406",
    "data-name": "Path 406",
    d: "M-1039.7,558.449l-9.276,3.81-6.372-25.325,9.276-3.81Z",
    transform: "translate(1055.346 -533.124)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_407",
    "data-name": "Path 407",
    d: "M-1039.7,558.449l-9.276,3.81-6.372-25.325,9.276-3.81Z",
    transform: "translate(1055.346 -533.124)",
    fill: "none",
    stroke: "#5e5f5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_268",
    "data-name": "Group 268",
    transform: "translate(40.475 111.733)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_408",
    "data-name": "Path 408",
    d: "M-1038.182,561.855l-9.288-2.736,4.664-25.847,9.289,2.736Z",
    transform: "translate(1047.471 -533.272)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_409",
    "data-name": "Path 409",
    d: "M-1038.182,561.855l-9.288-2.736,4.664-25.847,9.289,2.736Z",
    transform: "translate(1047.471 -533.272)",
    fill: "none",
    stroke: "#5e5f5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_269",
    "data-name": "Group 269"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_410",
    "data-name": "Path 410",
    d: "M-988.409,527.768c-1.695,20.859-13.595,75.139-19.95,92.779l-15.911-4.528c1.529-11.734,6.612-50.327,10.649-75.485.383-2.347-.808-4.644-2.7-5.238l-.024-.011-9.233-2.844v-.01c0-.019-.008-.066-.008-.153-.005.087-.013.135-.013.153v.01l-9.233,2.844c-1.906.584-3.1,2.891-2.728,5.249,4.053,25.2,9.152,63.915,10.665,75.551l-15.459,4.05c-6.4-17.754-18.722-71.558-20.41-92.367a17.827,17.827,0,0,1,.016-2.588l.024-.248a31.508,31.508,0,0,1,2.912-11.089l6.017-22.889,51.344,2.548,5.325,13a14.533,14.533,0,0,1,1.558,1.772c.895,1.2,1.821,2.366,2.793,3.467C-989.7,515.213-988.094,523.832-988.409,527.768Z",
    transform: "translate(1062.8 -490.954)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_411",
    "data-name": "Path 411",
    d: "M-988.409,527.768c-1.695,20.859-13.595,75.139-19.95,92.779l-15.911-4.528c1.529-11.734,6.612-50.327,10.649-75.485.383-2.347-.808-4.644-2.7-5.238l-.024-.011-9.233-2.844v-.01c0-.019-.008-.066-.008-.153-.005.087-.013.135-.013.153v.01l-9.233,2.844c-1.906.584-3.1,2.891-2.728,5.249,4.053,25.2,9.152,63.915,10.665,75.551l-15.459,4.05c-6.4-17.754-18.722-71.558-20.41-92.367a17.827,17.827,0,0,1,.016-2.588l.024-.248a31.508,31.508,0,0,1,2.912-11.089l6.017-22.889,51.344,2.548,5.325,13a14.533,14.533,0,0,1,1.558,1.772c.895,1.2,1.821,2.366,2.793,3.467C-989.7,515.213-988.094,523.832-988.409,527.768Z",
    transform: "translate(1062.8 -490.954)",
    fill: "none",
    stroke: "#5e5f5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_412",
    "data-name": "Path 412",
    d: "M-1028.022,548.7l-19.718-6.2a1.519,1.519,0,0,1-.837-1.764l.684-3.543c.15-.782.768-1.26,1.381-1.069l19.718,6.2a1.517,1.517,0,0,1,.834,1.764l-.681,3.543C-1026.792,548.411-1027.413,548.889-1028.022,548.7Z",
    transform: "translate(1086.076 -416.935)",
    fill: "#0e55e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_413",
    "data-name": "Path 413",
    d: "M-1036.5,542.718l-18.643,4.436c-.62.145-1.214-.375-1.331-1.167l-.523-3.588a1.474,1.474,0,0,1,.913-1.7l18.643-4.436c.618-.148,1.215.375,1.331,1.167l.523,3.588A1.474,1.474,0,0,1-1036.5,542.718Z",
    transform: "translate(1072.294 -416.674)",
    fill: "#0e55e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_414",
    "data-name": "Path 414",
    d: "M-1053.707,545.508a.962.962,0,0,1,.805-.882,16.617,16.617,0,0,0,5.017-1.164,18.842,18.842,0,0,0,4.555-2.64.736.736,0,0,1,1.088.185,15.889,15.889,0,0,1,1.833,3.345,31.414,31.414,0,0,1,1.779,6.767l-12.755,5.626a23.092,23.092,0,0,1-2.278-6.091A15.3,15.3,0,0,1-1053.707,545.508Z",
    transform: "translate(1077.392 -409.425)",
    fill: "#f5f6f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_415",
    "data-name": "Path 415",
    d: "M-1045.795,540.832a.743.743,0,0,1,1.035-.288,17.673,17.673,0,0,0,4.845,2.03,16.127,16.127,0,0,0,4.99.449.915.915,0,0,1,.885.824,19.1,19.1,0,0,1,.367,4.055,32.725,32.725,0,0,1-.959,7.037c-4.436-.938-9.41-1.014-13.849-1.951a38.7,38.7,0,0,1,.8-7.607A13.4,13.4,0,0,1-1045.795,540.832Z",
    transform: "translate(1086.248 -409.787)",
    fill: "#f5f6f6"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_416",
    "data-name": "Path 416",
    d: "M-1049.618,457.98l-.489,12.516,12.694.926.557-14.262Z",
    transform: "translate(1104.401 -403.889)",
    fill: "#fff",
    stroke: "#5e5f5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_417",
    "data-name": "Path 417",
    d: "M-1070.67,508.84a87,87,0,0,1,2.128-14.583c2.941-12.692,9.872-29.339,26.071-31.124,26.528-2.918,66.948-3.052,76.131,14.445s6.735,31.256,6.735,31.256l-21.5,4.541-74.05,1.51Z",
    transform: "translate(1070.67 -396.508)",
    fill: "#0e55e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418",
    "data-name": "Path 418",
    d: "M-1018.766,479.526a44.227,44.227,0,0,1-15.15.816l-.686,17.608s7.578,1.56,10.413-1.843S-1018.766,479.526-1018.766,479.526Z",
    transform: "translate(1129.832 -367.2)",
    fill: "#fff",
    stroke: "#5e5f5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_419",
    "data-name": "Path 419",
    d: "M-1070.67,479.572a44.049,44.049,0,0,0,15.087,1.479l-.232,17.619s-7.649,1.228-10.308-2.3S-1070.67,479.572-1070.67,479.572Z",
    transform: "translate(1070.67 -367.124)",
    fill: "#fff",
    stroke: "#5e5f5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_420",
    "data-name": "Path 420",
    d: "M-1002.679,455.495s-1.035,1.022-6.585.032c-4.982-.89-8.742-14.865-20.457-15.449-6.429-.319-9.339,2.73-9.339,2.73,0-1.32,3.173-3.7,3.173-3.7-11.718,1.552-9.962,8.8-9.962,8.8-12.9.945-9.009,18.965-9.009,18.965l.008-.005a12.874,12.874,0,0,0,.388,2.873l-.008.005s.679,4.819,5.249,11.744l.008.011a31.1,31.1,0,0,0,8.652,10.82,18.653,18.653,0,0,0,5.809.882,24.055,24.055,0,0,0,6.083-.882,31.277,31.277,0,0,0,7.179-8.235l.024-.032a61.151,61.151,0,0,0,6.213-13.046c.122-.317.229-.66.327-1.014l.026-.082h-.005a12.483,12.483,0,0,0,.333-1.685,14.364,14.364,0,0,0,10.461-5.566c-3.279.877-6.408-.462-7.324-3.6a9.327,9.327,0,0,0,3.472.393A5.511,5.511,0,0,0-1002.679,455.495Z",
    transform: "translate(1095.706 -433.497)",
    fill: "#8c8c8c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_421",
    "data-name": "Path 421",
    d: "M-1003.657,467.985a8.144,8.144,0,0,0-4.346-3.174s-.607-23.964-25.709-22.966c-20.885,1.067-19.713,24.513-19.713,24.513h0a8.162,8.162,0,0,0-4.278,1.449h0s-2.144-31.027,24.017-30.823S-1003.324,454.963-1003.657,467.985Z",
    transform: "translate(1091.873 -436.984)",
    fill: "#fff",
    stroke: "#5f5f5f",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_422",
    "data-name": "Path 422",
    d: "M-1029.133,455.854a8.364,8.364,0,0,1-8.444,8.2,8.074,8.074,0,0,1-3.538-.892,29.876,29.876,0,0,0,3.889-15.842h.084a8.007,8.007,0,0,1,2.073.312,8.159,8.159,0,0,1,4.388,3.118A8.382,8.382,0,0,1-1029.133,455.854Z",
    transform: "translate(1119.151 -420.024)",
    fill: "#f5f6f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_423",
    "data-name": "Path 423",
    d: "M-1046.015,462.952a8.132,8.132,0,0,1-4.758,1.568,8.237,8.237,0,0,1-8.219-8.325,8.455,8.455,0,0,1,3.372-6.772h0a8.141,8.141,0,0,1,4.217-1.613h0c.214-.018.427-.029.644-.029a8.045,8.045,0,0,1,1.433.119A29.253,29.253,0,0,0-1046.015,462.952Z",
    transform: "translate(1089.826 -419.272)",
    fill: "#f5f6f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_424",
    "data-name": "Path 424",
    d: "M-1050.7,504.525l.225,108.227h11.9l-.224-108.241q-3.616.032-7.3.029C-1047.652,504.541-1049.178,504.533-1050.7,504.525Z",
    transform: "translate(1103.426 -326.214)",
    fill: "#f5f6f6",
    stroke: "#5e5f5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_425",
    "data-name": "Path 425",
    d: "M-1006.458,462.562h-30.483c-15.588,0-28.227,11.575-28.227,25.852v76.971c0,4,3.541,7.24,7.908,7.24h71.122c4.367,0,7.908-3.242,7.908-7.24V488.414C-978.231,474.137-990.867,462.562-1006.458,462.562Z",
    transform: "translate(1079.694 -395.027)",
    fill: "#f5f6f6",
    stroke: "#5e5f5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_426",
    "data-name": "Path 426",
    d: "M-1059.667,505.753s-1.185,8.618,13.74,9.27,37.308,0,37.308,0,10.876-1.582,5.331-12.365Z",
    transform: "translate(1088.682 -329.254)",
    fill: "#f5f6f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_427",
    "data-name": "Path 427",
    d: "M-1062.568,509.2h83.833a3.2,3.2,0,1,0,0-6.4h-83.833a3.2,3.2,0,1,0,0,6.4Z",
    transform: "translate(1078.426 -329.023)",
    fill: "#f5f6f6",
    stroke: "#5e5f5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), /*#__PURE__*/React.createElement("g", {
    id: "Model_3",
    "data-name": "Model 3",
    transform: "translate(497.087 256.228)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_272",
    "data-name": "Group 272",
    transform: "translate(21.348 139.973)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_428",
    "data-name": "Path 428",
    d: "M-966.46,556.058l-9.276,3.766-6.372-25.033,9.276-3.766Z",
    transform: "translate(1001.789 -420.964)",
    fill: "#fff",
    stroke: "#5e5f5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_429",
    "data-name": "Path 429",
    d: "M-964.945,559.425l-9.289-2.7,4.665-25.55,9.288,2.7Z",
    transform: "translate(1014.708 -420.724)",
    fill: "#fff",
    stroke: "#5e5f5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_430",
    "data-name": "Path 430",
    d: "M-915.172,525.729c-1.7,20.618-13.592,74.275-19.948,91.712l-15.913-4.478c1.529-11.6,6.611-49.747,10.648-74.616.385-2.318-.805-4.592-2.7-5.178l-.024-.011-9.231-2.809v-.01c0-.019-.008-.066-.008-.151-.008.084-.016.132-.016.151v.01l-9.233,2.809c-1.9.578-3.1,2.86-2.725,5.188,4.05,24.917,9.149,63.181,10.665,74.682l-15.462,4.006c-6.4-17.55-18.72-70.735-20.407-91.306a17,17,0,0,1,.016-2.556l.021-.246a30.9,30.9,0,0,1,2.915-10.963l6.017-22.625,51.344,2.516,5.323,12.848a14.292,14.292,0,0,1,1.56,1.751c.9,1.183,1.822,2.339,2.793,3.427C-916.461,513.317-914.856,521.837-915.172,525.729Z",
    transform: "translate(989.563 -489.34)",
    fill: "#fff",
    stroke: "#5e5f5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_431",
    "data-name": "Path 431",
    d: "M-954.787,546.418l-19.718-6.131a1.5,1.5,0,0,1-.834-1.743l.681-3.5c.153-.771.771-1.244,1.381-1.053l19.718,6.128a1.5,1.5,0,0,1,.837,1.745l-.684,3.5C-953.557,546.135-954.175,546.608-954.787,546.418Z",
    transform: "translate(1012.839 -416.173)",
    fill: "#073aaa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_432",
    "data-name": "Path 432",
    d: "M-963.257,540.507l-18.643,4.386c-.621.145-1.217-.372-1.331-1.154l-.526-3.546a1.46,1.46,0,0,1,.914-1.682l18.643-4.383c.621-.148,1.217.37,1.331,1.151l.523,3.549A1.454,1.454,0,0,1-963.257,540.507Z",
    transform: "translate(999.056 -415.914)",
    fill: "#073aaa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_433",
    "data-name": "Path 433",
    d: "M-980.469,543.264a.957.957,0,0,1,.8-.871,16.722,16.722,0,0,0,5.019-1.151,18.888,18.888,0,0,0,4.555-2.609.737.737,0,0,1,1.085.185,15.566,15.566,0,0,1,1.835,3.3,31.008,31.008,0,0,1,1.78,6.693l-12.755,5.558a22.646,22.646,0,0,1-2.281-6.02A15.015,15.015,0,0,1-980.469,543.264Z",
    transform: "translate(1004.155 -408.75)",
    fill: "#f5f6f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_434",
    "data-name": "Path 434",
    d: "M-972.841,538.642a.751.751,0,0,1,1.037-.282,17.746,17.746,0,0,0,4.845,2.006,16.433,16.433,0,0,0,4.99.444.911.911,0,0,1,.885.816,18.944,18.944,0,0,1,.367,4.008,32.149,32.149,0,0,1-.958,6.955l-13.313-2.78a25.3,25.3,0,0,1,.264-6.667A13.207,13.207,0,0,1-972.841,538.642Z",
    transform: "translate(1013.293 -409.107)",
    fill: "#f5f6f6"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_435",
    "data-name": "Path 435",
    d: "M-976.6,457.323l-.489,12.516,12.693.926.557-14.262Z",
    transform: "translate(1031.38 -403.231)",
    fill: "#fff",
    stroke: "#5e5f5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_436",
    "data-name": "Path 436",
    d: "M-997.648,508.185s1.672-42.787,28.2-45.707,66.951-3.052,76.131,14.443,6.735,31.259,6.735,31.259l-21.5,4.541-74.048,1.508Z",
    transform: "translate(997.648 -395.85)",
    fill: "#073aaa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_437",
    "data-name": "Path 437",
    d: "M-945.744,478.87a44.215,44.215,0,0,1-15.148.816l-.689,17.608s7.578,1.56,10.416-1.846S-945.744,478.87-945.744,478.87Z",
    transform: "translate(1056.81 -366.541)",
    fill: "#fff",
    stroke: "#5e5f5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_438",
    "data-name": "Path 438",
    d: "M-997.648,478.916a44.136,44.136,0,0,0,15.09,1.479l-.233,17.619s-7.652,1.225-10.308-2.3S-997.648,478.916-997.648,478.916Z",
    transform: "translate(997.648 -366.466)",
    fill: "#fff",
    stroke: "#5e5f5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_439",
    "data-name": "Path 439",
    d: "M-928.388,454.891s-1.067,1.053-6.78.032c-5.13-.916-9-15.3-21.062-15.9-6.62-.33-9.614,2.812-9.614,2.812,0-1.362,3.264-3.81,3.264-3.81-12.061,1.6-10.255,9.056-10.255,9.056-13.278.974-9.276,19.525-9.276,19.525l.011,0a13.226,13.226,0,0,0,.4,2.954l-.008.005s.7,4.964,5.4,12.093l.008.01a32.049,32.049,0,0,0,8.908,11.14,19.194,19.194,0,0,0,5.98.908,24.762,24.762,0,0,0,6.263-.908,32.3,32.3,0,0,0,7.39-8.475l.024-.034a62.893,62.893,0,0,0,6.4-13.434c.124-.325.235-.676.338-1.043l.027-.084h-.005a12.372,12.372,0,0,0,.34-1.735,14.791,14.791,0,0,0,10.773-5.73c-3.38.9-6.6-.475-7.541-3.7a9.568,9.568,0,0,0,3.572.407A5.676,5.676,0,0,0-928.388,454.891Z",
    transform: "translate(1022.205 -433.546)",
    fill: "#8c8c8c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_440",
    "data-name": "Path 440",
    d: "M-932.6,470.42a8.158,8.158,0,0,0-4.349-3.176s2.8-27.05-22.3-26.052c-20.885,1.064-20.97,24.909-20.97,24.909h0a8.129,8.129,0,0,0-4.275,1.45h0s-.887-31.423,25.274-31.222S-932.269,457.4-932.6,470.42Z",
    transform: "translate(1019.218 -436.327)",
    fill: "#fff",
    stroke: "#5f5f5f",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_441",
    "data-name": "Path 441",
    d: "M-973.414,462.78a8.133,8.133,0,0,1-4.816,1.384,8.233,8.233,0,0,1-7.895-8.631,8.466,8.466,0,0,1,3.628-6.64h0a8.15,8.15,0,0,1,4.275-1.45h0c.211-.011.425-.011.642-.005a8.189,8.189,0,0,1,1.429.174A29.259,29.259,0,0,0-973.414,462.78Z",
    transform: "translate(1016.539 -418.107)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_442",
    "data-name": "Path 442",
    d: "M-956.534,455.731a8.362,8.362,0,0,1-8.18,8.465,8.025,8.025,0,0,1-3.564-.779,29.823,29.823,0,0,0,3.385-15.958h.087a8.077,8.077,0,0,1,2.081.243,8.148,8.148,0,0,1,4.483,2.981A8.378,8.378,0,0,1-956.534,455.731Z",
    transform: "translate(1045.825 -418.068)",
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_443",
    "data-name": "Path 443",
    d: "M-977.69,503.048l.214,112.5h11.216l-.211-112.513q-3.41.036-6.886.034C-974.812,503.066-976.251,503.056-977.69,503.048Z",
    transform: "translate(1030.386 -326.907)",
    fill: "#f5f6f6",
    stroke: "#5e5f5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_77",
    "data-name": "Rectangle 77",
    d: "M3.822,0H59.243a3.822,3.822,0,0,1,3.822,3.822v7.737a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V3.822A3.822,3.822,0,0,1,3.822,0Z",
    transform: "translate(27.38 281.213)",
    fill: "#f5f6f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_444",
    "data-name": "Path 444",
    d: "M-986.645,505.1s-1.183,8.618,13.74,9.27,37.311,0,37.311,0,10.873-1.584,5.331-12.367Z",
    transform: "translate(1015.66 -328.597)",
    fill: "#f5f6f6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_445",
    "data-name": "Path 445",
    d: "M-933.436,461.906h-30.483c-15.591,0-28.228,11.573-28.228,25.852v76.968c0,4,3.538,7.243,7.908,7.243h71.123c4.367,0,7.908-3.242,7.908-7.243V487.758C-905.208,473.479-917.847,461.906-933.436,461.906Z",
    transform: "translate(1006.673 -394.368)",
    fill: "#f5f6f6",
    stroke: "#5e5f5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_446",
    "data-name": "Path 446",
    d: "M-989.546,508.541h83.836a3.2,3.2,0,1,0,0-6.4h-83.836a3.2,3.2,0,1,0,0,6.4Z",
    transform: "translate(1005.404 -328.364)",
    fill: "#f5f6f6",
    stroke: "#5e5f5e",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), /*#__PURE__*/React.createElement("g", {
    id: "Cup",
    transform: "translate(449.574 355.305)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_478",
    "data-name": "Path 478",
    d: "M-1009.636,474.387v2.846a6.312,6.312,0,0,0-6.007,6.3,6.313,6.313,0,0,0,6.2,6.3,5.032,5.032,0,0,0,4.84,3.649h6.754a5.031,5.031,0,0,0,5.03-5.032V474.387Zm-3.85,9.143a4.156,4.156,0,0,1,3.85-4.14v8.277A4.153,4.153,0,0,1-1013.486,483.53Z",
    transform: "translate(1015.643 -472.972)",
    fill: "#fff",
    stroke: "#5f5f5f",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_479",
    "data-name": "Path 479",
    d: "M-1009.838,474.387h-3.53v14.062a5.031,5.031,0,0,0,5.032,5.032h6.754a5.021,5.021,0,0,0,4.035-2.025",
    transform: "translate(1019.375 -472.972)",
    fill: "#fff",
    stroke: "#5f5f5f",
    strokeMiterlimit: 10,
    strokeWidth: 0.25,
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_480",
    "data-name": "Path 480",
    d: "M-996.526,475.427c0,.869-3.773,1.574-8.428,1.574s-8.431-.7-8.431-1.574,3.773-1.576,8.431-1.576S-996.526,474.556-996.526,475.427Z",
    transform: "translate(1019.349 -473.851)",
    fill: "#fff",
    stroke: "#5f5f5f",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_481",
    "data-name": "Path 481",
    d: "M-997.63,475.2c0,.668-3.469,1.212-7.747,1.212s-7.749-.544-7.749-1.212,3.469-1.215,7.749-1.215S-997.63,474.532-997.63,475.2Z",
    transform: "translate(1019.772 -473.626)",
    fill: "#fff",
    stroke: "#5f5f5f",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), /*#__PURE__*/React.createElement("g", {
    id: "Cup-2",
    "data-name": "Cup",
    transform: "translate(251.896 354.811)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_482",
    "data-name": "Path 482",
    d: "M-1084.505,474.2v2.846a6.311,6.311,0,0,0-6.006,6.3,6.31,6.31,0,0,0,6.2,6.3,5.034,5.034,0,0,0,4.839,3.652h6.751a5.033,5.033,0,0,0,5.032-5.032V474.2Zm-3.852,9.143a4.155,4.155,0,0,1,3.852-4.137v8.275A4.154,4.154,0,0,1-1088.358,483.343Z",
    transform: "translate(1090.512 -472.785)",
    fill: "#fff",
    stroke: "#5f5f5f",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_483",
    "data-name": "Path 483",
    d: "M-1084.707,474.2h-3.53v14.065a5.033,5.033,0,0,0,5.032,5.032h6.751a5.023,5.023,0,0,0,4.037-2.028",
    transform: "translate(1094.244 -472.785)",
    fill: "#fff",
    stroke: "#5f5f5f",
    strokeMiterlimit: 10,
    strokeWidth: 0.25,
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_484",
    "data-name": "Path 484",
    d: "M-1071.395,475.24c0,.869-3.773,1.574-8.43,1.574s-8.428-.7-8.428-1.574,3.773-1.576,8.428-1.576S-1071.395,474.369-1071.395,475.24Z",
    transform: "translate(1094.217 -473.664)",
    fill: "#fff",
    stroke: "#5f5f5f",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_485",
    "data-name": "Path 485",
    d: "M-1072.5,475.016c0,.671-3.469,1.212-7.749,1.212s-7.747-.541-7.747-1.212,3.469-1.215,7.747-1.215S-1072.5,474.345-1072.5,475.016Z",
    transform: "translate(1094.641 -473.439)",
    fill: "#fff",
    stroke: "#5f5f5f",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin1);
export default __webpack_public_path__ + "static/media/login-1.e6074e3a3620d0ec632970c8ceb82d4a.svg";
export { ForwardRef as ReactComponent };